import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReportLocationEnum } from '../../../enums/reportLocationEnum';
import { PortCallStatus } from '../../../enums/portCallStatus';
import { PortCall } from '../../../types/ViewModel/PortCall';
import { StatusIcon } from './CargoConsumablesIcon.styles';

export const getRobIcon = (portCallItem: PortCall) => {
    if (portCallItem.chemicalRobForPortCall && portCallItem.reportLocation === ReportLocationEnum.Port) {
        return (
            <StatusIcon className="status-has-reported-rob" rightPos={'10px'}>
                <FontAwesomeIcon title="ROB has been reported for port call" icon="database" />
            </StatusIcon>
        );
    } else if (
        !portCallItem.chemicalRobForPortCall &&
        portCallItem.reportLocation === ReportLocationEnum.Port &&
        portCallItem.portCallStatus === PortCallStatus.Departed
    ) {
        return (
            <StatusIcon className="status-has-missing-rob" rightPos={'10px'}>
                <FontAwesomeIcon title="ROB has not been reported for port call" icon="database" />
            </StatusIcon>
        );
    }
};
